// Reglas de validación compartidas por los formularios de Contacto y Calendarización.

export const PHONE_RE = /^\d{10,15}$/;
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidName(v) {
  return !!v && v.trim().length >= 2;
}

export function isValidPhone(v) {
  return !!v && PHONE_RE.test(v.trim());
}

export function isValidEmail(v) {
  return !!v && EMAIL_RE.test(v.trim());
}

// Deja solo dígitos mientras el usuario escribe, para que el teléfono nunca acepte letras/símbolos.
export function sanitizePhone(v) {
  return v.replace(/\D/g, "").slice(0, 15);
}
